module.exports = __webpack_public_path__ + "static/media/ic-user-old.fc05b443.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-user-old.svg
// module id = 678
// module chunks = 14